import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/gymnastics/Index.vue')

export const gymnasticsRoute: RouteConfig = {
  path: '/gymnastics-activity',
  name: 'gymnastics_activity',
  component: Index,
  meta: {
    title: '广播体操开学活动',
  },
}

export default [gymnasticsRoute]

export function navigateToFallSemester2021BroadcastGymnasticsActivity(router: VueRouter) {
  router.push({ name: gymnasticsRoute.name })
}

export function redirectToFallSemester2021BroadcastGymnasticsActivity(router: VueRouter) {
  router.replace({ name: gymnasticsRoute.name })
}
